export enum CommonActionType {
  CHANGE_LANGUAGE = 'COMMON/CHANGE_LANGUAGE',
}

export const changeLanguage = (lang: string) => ({
  type: CommonActionType.CHANGE_LANGUAGE,
  lang,
});
